import React, { Component } from "react";
import { Form, Checkbox } from "react-form";

import InputText from "components/form-fields/InputText";
import Select from "components/form-fields/Select";

export default class extends Component {
  onSubmit = (data) => {
    this.props.handleFormSubmit(data);
  };

  render() {
    const yesNoOption = [
      { label: "No", value: 0 },
      { label: "Yes", value: 1 },
    ];
    const { defaultValues } = this.props;
    return (
      <Form onSubmit={this.onSubmit} defaultValues={defaultValues}>
        {(formApi) => (
          <form onSubmit={formApi.submitForm}>
            <div className="box">
              <div className="columns">
                <div className="column">
                  <InputText
                    required
                    field="name"
                    label="Name"
                    placeholder="Name"
                  />
                </div>
                <div className="column">
                  <InputText
                    required
                    type="email"
                    field="email"
                    label="Email"
                    placeholder="Email"
                  />
                </div>
              </div>
              <div className="columns">
                <div className="column">
                  <Select
                    label="Superuser"
                    field="superuser"
                    placeholder="is superuser?"
                    options={yesNoOption}
                  />
                </div>

                <div className="column">
                  <Select
                    label="Revoked"
                    field="revoked"
                    placeholder="is revoked?"
                    options={yesNoOption}
                  />
                </div>
              </div>
              <div className="columns">
                <div className="column">
                  <div className="field">
                    <label className="label">God user?</label>
                    <div
                      className="control checkbox"
                      style={{ marginRight: "10px" }}
                    >
                      <label>Read </label>
                      <Checkbox label="God user" field="god_user_details.read" />
                    </div>
                    <div
                      className="control checkbox"
                      style={{ marginRight: "10px" }}
                    >
                      <label>Create </label>
                      <Checkbox label="God user" field="god_user_details.create" />
                    </div>
                    <div
                      className="control checkbox"
                      style={{ marginRight: "10px" }}
                    >
                      <label>Update </label>
                      <Checkbox label="God user" field="god_user_details.update" />
                    </div>
                    <div
                      className="control checkbox"
                      style={{ marginRight: "10px" }}
                    >
                      <label>Delete </label>
                      <Checkbox label="God user" field="god_user_details.delete" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <button className="button is-fullwidth is-info is-medium">
              Submit
            </button>
          </form>
        )}
      </Form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/User/Form.js